import React, { useCallback, useContext, useEffect, useState ,  } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "../../../assets/AdminCss/cricket.css";
import { useLocation, useParams } from "react-router-dom";
import AdminSidebar from './AdminSidebar';
import AdminHeader from './AdminHeader';

import axios from "axios"
import { AuthContext, base_url } from "../../../context/Authcontext";

import CricketScoreboard from "../../CricketScoreboard";
import BetModal from "./BetModal";

const MarketAnalysisBets = () => {
  const { marketId2 } = useParams();
  // console.log("marketnmndm", marketId2);
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  // console.log( "trgyjbrh3kgk" ,marketId2); // e.g., "34359959"
   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
       const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);


  const [isSidebar, setSidebar] = useState(false);
  const location = useLocation();
  const [back1, setBack1] = useState([]);
  const [lay1, setLay1] = useState([]);
  const [back2, setBack2] = useState([]);
  const [lay2, setLay2] = useState([]);
  
  const [profit, setProfit] = useState(0);
  
  
  const [newactive, setNewActive] = useState(0);
  const [isExpanded, setIsExpanded] = useState(1);
  const [isExpanded1, setIsExpanded1] = useState(1);
  
  const [isExpanded3, setIsExpanded3] = useState(1);
  const [isExpanded4, setIsExpanded4] = useState(1);
  const [isExpanded5, setIsExpanded5] = useState(1);
  const [isExpanded6, setIsExpanded6] = useState(1);
  const [fancyData, setFancyData] = useState();



  const [selectedPrice, setSelectedPrice] = useState();
  const [money, setMoney] = useState(0);
  const { isAuthenticated } = useContext(AuthContext);
  const [matchLibalities , setMatchLiblities] = useState({odds:{}, bookmaker:{}})

  const [marketId, setMarketId] = useState(() => {
    return sessionStorage.getItem("marketId") || "";
  });

  const [runner1, setRunner1] = useState(() => {
    return sessionStorage.getItem("runner1") || "";
  });

  const [runner2, setRunner2] = useState(() => {
    return sessionStorage.getItem("runner2") || "";
  });

 

  const competiton = sessionStorage.getItem("competitionname");
  const event = sessionStorage.getItem("eventname");
  const selectionid1 = sessionStorage.getItem("selectionid1");
  const selectionid2 = sessionStorage.getItem("selectionid2");

  const eventId = sessionStorage.getItem("eventid");

  const [fancy, setFancy] = useState([]);

  const [selectedMarket, setSelectedMarket] = useState();
  
  const [startTime, setStartTime] = useState();
  const [book1, setBook1] = useState([]);
  const [book2, setBook2] = useState([]);
  const [channel, setChannel] = useState();
  const [betData, setBetData] = useState([]);
  const [fancyBetData, setFancyBetData] = useState([]);
  const [bookmakerProfit, setBookMakerProfit] = useState(0);
  const [toss1, setToss1] = useState();
  const [toss2, setToss2] = useState();
  const [play, setPlay] = useState(false);
  const [mini1, setMini1] = useState([]);
  const [mini2, setMini2] = useState([]);
  const [oddEven, setOddEven] = useState([]);
  const [session, setSession] = useState([]);
  const [wpMarket, setWPMarket] = useState([]);
  const [fancySrno, setFancySrno] = useState(0);
  const [minOdds, setMinOdds]= useState(0);
  const [minBookmaker, setMinBookmaker]= useState(0);
  const [minMiniBook, setMinMiniBook]= useState(0);
  const [minFancy, setMinFancy]= useState(0);
  const [maxOdds, setMaxOdds]= useState(0);
  const [maxBookmaker, setMaxBookmaker]= useState(0);
  const [maxMiniBook, setMaxMiniBook]= useState(0);
  const [maxFancy, setMaxFancy]= useState(0);
  const [unmatch, setUnmatch]= useState([]);

  const [oddslibalityteam1 , setOddslibalityTeam1]= useState([]);
  const [oddslibalityteam2 , setOddslibalityTeam2]= useState([]);

  const [bookmakerLiablitiesteam1 , setBookmakerLiablitiesteam1]= useState([]);
  const [bookmakerLiablitiesteam2 , setBookmakerLiablitiesteam2]= useState([]);

  // const [fancyLiablities , setFancyLiablities]= useState([]);


 


  // console.log('selec',selectedMarket);

  // console.log('iidd',marketId);

  function formatDate(isoString) {
    const date = new Date(isoString);
    return date.toLocaleString("en-US", {
      year: "2-digit",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  }

  function isTenMinutesRemaining(isoString) {
    const targetTime = new Date(isoString).getTime(); // Convert given time
    const currentTime = new Date().getTime(); // Get current time

    // Calculate the difference in milliseconds
    const timeDifference = targetTime - currentTime;

    // Convert milliseconds to minutes
    const minutesRemaining = timeDifference / (1000 * 60);

    return minutesRemaining > 10;
  }

  function convertDecimalToInteger(decimalValue) {
    // Get the integer part
    const integerPart = Math.floor(decimalValue);

    // Get the decimal part
    const decimalPart = decimalValue - integerPart;

    // Apply the rule
    if (decimalPart >= 0.5) {
      return integerPart + 1; // Round up
    } else {
      return integerPart; // Round down
    }
  }


   const betDataa = async () => {
    const marketId33 = sessionStorage.getItem("marketId")
    // console.log("marketid ", marketId33) 
    try {
      const response = await axios.post(
        base_url + "/admin/webapi/betData",
        { marketId33 },
        {
          withCredentials: true,
          headers: {
            "content-type": "application/json",
          },
        }
      );

      // console.log("databet", response);

      if (response?.data.success) {
        const sportsBets = response?.data.sportsBets;
        const fancyBets = response?.data.fancyBets;
        const unmach= response?.data.unmatch;
        // console.log('ddd',data);
        setBetData(sportsBets);
        setFancyBetData(fancyBets);
        setUnmatch(unmach);
      }
    } catch (err) {
      console.log(err);
    }
  };




 

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 991) {
        setSidebar(true);
      } else {
        setSidebar(false);
      }
    };

    if (location.state?.marketId) {
      sessionStorage.setItem("marketId", location.state.marketId);
      setRunner1(location.state.marketId);
    }

    if (location.state?.runner1) {
      sessionStorage.setItem("runner1", location.state.runner1);
      setRunner2(location.state.runner1);
    }

    if (location.state?.runner2) {
      sessionStorage.setItem("runner2", location.state.runner2);
      setMarketId(location.state.runner2);
    }

    const proft =
      parseFloat(selectedPrice) * parseFloat(money) - parseFloat(money);
    setProfit(proft.toFixed(1));

    const fancyprofit = () => {
      const prff = (parseFloat(selectedPrice) * parseFloat(money)) / 100;

      // console.log('fancc',prff);
      const value = convertDecimalToInteger(prff);

      setBookMakerProfit(value);
    };

    // console.log('prff',proft);
    // Add event listener for resize
    window.addEventListener("resize", handleResize);
    handleResize();
    fancyprofit();

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
      // sessionStorage.clear();
    };
  }, [location.state, money, selectedPrice]);
const handlelayChange = (action) => {
    setSelectedPrice((prev) => {
      let newMoney = prev < 1.01 ? 1.01 : prev;

      if (action === 0) {
        return Math.max(0, (parseFloat(newMoney) - 0.01).toFixed(2));
      } else {
        return (parseFloat(newMoney) + 0.01).toFixed(2);
      }
    });
  };

   const handlefancyChange = (action) => {
    setSelectedMarket((prev) => {
      let newMoney = prev <= 1 ? 1 : prev;

      if (action === 0) {
        return Math.max(0, parseFloat(newMoney) - 1);
      } else {
        return parseFloat(newMoney) + 1;
      }
    });
  };


  // console.log(channel)

  useEffect(() => {
    window.scrollTo(0, 0);

    const fancyData = async () => {
      try {
        const response = await axios.get(base_url + "/api/webapi/getFancy");

        if (response?.data?.data && Array.isArray(response?.data.data)) {
          const fetchedData = response.data.data;


          // const fancyIds = fancyBetData.map(item => item.fancyId);
          // console.log(fancyBetData,"fegwjhgfhgrhygryfhghy")

          const fancyRunnerNames = fancyBetData.map(item => item.runnerName);

          console.log("fancy runners name" , fancyRunnerNames);
          console.log("fetched data ius ", fetchedData)


          const competitionId = sessionStorage.getItem("eventid");
          const matchedData = fetchedData.filter(
            (item) => item.eventId === competitionId  &&  fancyRunnerNames.includes(item.marketName)

          );


          const oddData = matchedData.filter((item) => {
            return (
              (item.marketName.includes("Odd") ||
                item.marketName.includes("even")) &&
              !item.marketName.includes("Wicket") &&
              !item.marketName.includes("Fall") &&
              !item.marketName.includes("Boundaries")
            );
          });

          // console.log(oddData, "nejjcncj");
          const sess = matchedData.filter((item) => {
            return (
              (item.marketName.includes("Over") ||
                item.marketName.includes("Match")) &&
              !item.marketName.includes("Lambi") &&
              !item.marketName.includes("Fall") &&
              !item.marketName.includes("Boundaries")
            );
          });
          const wp = matchedData.filter(
            (item) =>
              item.marketName.includes("Fall") ||
              item.marketName.includes("fall") ||
              item.marketName.includes("Boundaries") ||
              item.marketName.includes("Wicket")
          );
          const mtch = matchedData.filter((item) => {
            return (
              !item.marketName.includes("Odd") &&
              !item.marketName.includes("Even") &&
              !item.marketName.includes("Over") &&
              !item.marketName.includes("Match") &&
              !item.marketName.includes("Fall") &&
              !item.marketName.includes("Wicket") &&
              !item.marketName.includes("Boundaries")
            );
          });

          // console.log(sess,"cdvvver")

          setFancyData(matchedData);
          setSession(sess);
          setOddEven(oddData);
          setWPMarket(wp);
          setFancy(mtch);
        } else {
          setFancy([]);
        }
      } catch (err) {
        console.error("Error fetching fancy data:", err);
        setFancy([]);
      }
    };

    const bookMakerData = async () => {
      try {
        const response = await axios.get(base_url + "/api/webapi/getBookMaker");
        // console.log("Full API Response:", response.data);

        if (response?.data?.data && Array.isArray(response.data.data)) {
          const fetchedData = response?.data.data;
          // console.log('fetch mini',fetchedData);

          const fancyRunnerNames = fancyBetData.map(item => item.runnerName);

          const competitionId = sessionStorage.getItem("eventid");

          // console.log("fancy data is dewdff ", fancyBetData);
          // console.log("fetched data is ", fetchedData);

          const tossMatchedData = fetchedData.filter(
            (item) =>
              item.eventId === competitionId &&
              item.marketName === "To Win The Toss" && fancyRunnerNames.includes( "To Win The Toss")
          );

          const bookmakerData = fetchedData.filter(
            (item) =>
              item.eventId === competitionId && item.marketName === "BOOKMAKER"
          );

          const miniBookmaker = fetchedData.filter(
            (item) =>
              item.eventId === competitionId &&
              item.marketName === "MINI BOOKMAKER"
          );

          // console.log("mini book maker Data:", miniBookmaker);

          const mini2 = miniBookmaker[0]?.runner[0];
          const mini1 = miniBookmaker[0]?.runner[1];

          // console.log(mini1, mini2);

          const toss1 = tossMatchedData[0]?.runner[0];
          const toss2 = tossMatchedData[0]?.runner[1];
          // console.log(toss1, toss2);

          const bookmaker1 = bookmakerData[0]?.runner[0];
          const bookmaker2 = bookmakerData[0]?.runner[1];

          // console.log(bookmaker1, bookmaker2);

          setBook1(bookmaker2);
          setBook2(bookmaker1);
          setToss1(toss1);
          setToss2(toss2);
          setMini1(mini1);
          setMini2(mini2);
        } else {
          setFancy([]);
        }
      } catch (err) {
        console.error("Error fetching fancy data:", err);
        setFancy([]);
      }
    };

    const backLay = async () => {
      try {
        const response = await axios.get(
          base_url + `/api/webapi/market/${marketId2}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        // console.log('reees backlay dbsysjnsiusndijdk',response);
        const status1 = response?.data.result[0]?.status;
        const status2 = response?.data.result[1]?.status;
        // console.log(status1);
        // console.log(status2);

        if (status1 === "ACTIVE") {
          const backk1 = response?.data.result[0]?.ex?.availableToBack;
          const layy1 = response?.data.result[0]?.ex?.availableToLay;

          setBack1(backk1);
          setLay1(layy1);
        }

        if (status2 === "ACTIVE") {
          const backk2 = response?.data.result[1]?.ex?.availableToBack;
          const layy2 = response?.data.result[1]?.ex?.availableToLay;

          setBack2(backk2);
          setLay2(layy2);
        }
      } catch (err) {
        console.log("Error fetching in odds data", err);
      }
    };

     const getMatchLiablities = async () => {
  console.log("libality called");

  try {
    const response = await axios.get(`${base_url}/api/webapi/getAdminMatchLiablity/${eventId}`, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });

    const data = response.data;

    console.log("Liabilities data:", data);

    let team1Odds = 0;
    let team2Odds = 0;
    let team1Bookmaker = 0;
    let team2Bookmaker = 0;

    data.forEach((bet) => {
      const { type, runnerName, betAmount } = bet;
      const amount = Number(betAmount);

      const sideKey = type.toLowerCase().replace(" ", "");

      if (sideKey === "odds") {
        if (runnerName === bet.team1) {
          team1Odds += amount;
        } else if (runnerName === bet.team2) {
          team2Odds += amount;
        }
      }

      if (sideKey === "bookmaker") {
        if (runnerName === bet.team1) {
          team1Bookmaker += amount;
        } else if (runnerName === bet.team2) {
          team2Bookmaker += amount;
        }
      }
    });

    setOddslibalityTeam1(team1Odds);
    setOddslibalityTeam2(team2Odds);

    setBookmakerLiablitiesteam1(team1Bookmaker);
    setBookmakerLiablitiesteam2(team2Bookmaker);
  } catch (error) {
    console.error("Error fetching match liabilities:", error);
  }
};



    const sessiontime = sessionStorage.getItem("time");
    const time = formatDate(sessiontime);
    // console.log('time',time);
    setStartTime(time);

    const updateData = async () => {
           betDataa()
     await fancyData();
     await bookMakerData();
      await backLay();
      await getMatchLiablities();
     
    };

//     setInterval(() => {
//   betDataa();
//   fancyData();
// }, 1000);




  








    const intervalId = setInterval(updateData, 1000);

    // Cleanup function to clear interval on component unmount
    return () => clearInterval(intervalId);
    }, []);

   useEffect(() => {
      const handleResize = () => {
        const mobile = window.innerWidth < 768;
        setIsMobile(mobile);
        
        // On desktop, sidebar should always be "open"
        if (!mobile) {
          setIsSidebarOpen(true);
        }
      };
      
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

  // console.log('matchess',wpMarket);

  // console.log("fancy bet data is devanshs sijski", fancyBetData)


  

  

  return (
    <>
    <div className="wrapper">
       
        
        {/* Content Wrapper - Use conditional class and margin */}
        <div
          className={`content-wrapper d-flex flex-column ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
          style={{
            marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
            transition: "margin-left 0.3s ease"
          }}
        >
       <div _ngcontent-jrx-c95="" className="head-container">
              <div _ngcontent-jrx-c95="" className="body-container">
              

               

                  <div className="news-bar">
                    <marquee style={{ width: "100%" }}>
                      <p className="m-0 w-100">
                        👉IPL MONTH DHAMAKA OFFER..GET 3% REFILL BONUS ON EVERY
                        DEPOSIT... USDT DEPOSIT OPTION IS ALSO AVAILABLE ON OUR
                        SITE👈👈...TO CONFIRM DEPOSIT BRANCH NUMBER CONTACT
                        HELPDESK NO +265899881378
                      </p>
                    </marquee>
                  </div>

                   <div className=" d-flex flex-column flex-lg-row justify-content-between mainn w-100 ">
                    <div className="match-content">
                      <div className="d-flex gap-5 align-items-center">
                        {/* <span>Time Remaining: </span> */}
                      </div>

                      <CricketScoreboard />
                      {/* <p
                        className="breadcrumb mt-3"
                        style={{ fontFamily: "sans-serif", color: "grey" }}
                      >
                        Home &gt; Cricket &gt; {competiton} &gt;
                        {event} &gt; Match Odds
                      </p> */}
                      {/* <span className="text-info fs-5 inline">Start Time: &nbsp;{startTime}</span> */}

                      <div className="match-section">
                        <div className="match-header d-flex align-items-end gap-2 ">
                          <div className="d-flex flex-lg-row flex-column  flex-md-row align-items-baseline">
                            <p className="bg-yellow text-black pt-2 pb-2 me-3 px-2 rad bett">
                              Match Odds
                            </p>
                            {/* <p className="d-flex gap-1 fszz">
                              <span>
                                Min:{minOdds} <span>|</span>{" "}
                              </span>{" "}
                              Max:{maxOdds}
                            </p> */}
                          </div>

                         
                          <BetModal betData={betData}  type="odds" />
                        

                          <div
                            className="d-flex align-items-end gap-4 ms-0 ms-md-auto me-4 mt-2 mt-md-0"
                            style={{ height: "5rem" }}
                          >
                            <p className="text-info fs-5">Back</p>
                            <p className="text-pink fs-5">Lay</p>
                          </div>
                        </div>

                        <div className="betting-options d-flex flex-column  gap-2">
                          <div className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-center border-2 bg-dark p-2">
                            <h5
                              className="fs-4 text-wrap run"
                              id={selectionid1}
                            >
                              {runner1}
                            </h5>
<p>{oddslibalityteam1}</p>
                            <div className="d-flex gap-2">
                             

                              {back1
                                .slice()
                                .reverse()
                                .map((bc, index) => (
                                  <div
                                    className={`rounded p-2 fs-5 h-75 text-center cursor-pointer ${
                                      index < back1.length - 1
                                        ? "bg-secondary dnone"
                                        : "bg-info"
                                    }`}
                                    
                                    style={{ width: "4rem" }}
                                  >
                                    {bc.price}
                                  </div>
                                ))}

                              {lay1.map((bc, index) => (
                                <div
                                  className={`rounded p-2 fs-5 h-75 text-center cursor-pointer ${
                                    index === 0
                                      ? "bg-pink1"
                                      : "bg-secondary dnone"
                                  }`}
                                  
                                  style={{ width: "4rem" , backgroundColor:"#E83E8C" }}
                                >
                                  {bc.price}
                                </div>
                              ))}
                            </div>
                          </div>

                          <div className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center border-2 bg-dark p-2">
                            <h5
                              className="fs-4 text-wrap run"
                              id={selectionid2}
                            >
                              {runner2}
                            </h5>
<p>{oddslibalityteam2}</p>
                            <div className="d-flex  gap-2">
                             

                              {back2
                                .slice()
                                .reverse()
                                .map((bc, index) => (
                                  <div
                                    className={`rounded p-2 fs-5 h-100 text-center cursor-pointer ${
                                      index < back2.length - 1
                                        ? "bg-secondary dnone"
                                        : "bg-info"
                                    }`}
                                    
                                    style={{ width: "4rem" }}
                                  >
                                    {bc.price}
                                  </div>
                                ))}

                              {lay2.map((bc, index) => (
                                <div
                                  className={`rounded p-2 fs-5 h-100 text-center cursor-pointer ${
                                    index === 0
                                      ? "bg-pink1"
                                      : "bg-secondary dnone"
                                  }`}
                                 
                                  style={{ width: "4rem" ,  backgroundColor:"#E83E8C" }}
                                >
                                  {bc.price}
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>


                        {/* bookmaker */}
                        <div className="d-flex align-items-start gap-2 mt-4">
                          <div className="d-flex flex-lg-row flex-column flex-md-row align-items-baseline">
                            <p className="bg-yellow text-black pt-2 pb-2 me-3 px-2 rad bett">
                              BookMaker
                            </p>
                            {/* <p className="d-flex gap-1 fszz">
                              <span>
                                Min:{minBookmaker} <span>|</span>{" "}
                              </span>{" "}
                              Max:{maxBookmaker}
                            </p> */}
                          </div>

                        <BetModal betData={betData} type="book maker" />
                          {/* <p
                            className="btn btn-success rounded-pill text-black"
                            style={{ marginTop: "-6px" }}
                          >
                          <i className="bi bi-book"></i>
                          </p> */}

                          {/* Toggle Button */}
                          <button
                            className="btn ms-auto me-4  white"
                            onClick={() =>
                              setIsExpanded(isExpanded === 1 ? 0 : 1)
                            }
                            style={{ fontSize: "1.5rem", lineHeight: 1 }}
                          >
                            {isExpanded === 1 ? "−" : "+"}
                          </button>
                        </div>

                        {/* Wrap the betting options in a conditional render based on isExpanded state */}
                        {isExpanded === 1 && (
                          <div className="betting-options d-flex flex-column  gap-2">
                            <div className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center border-2 bg-dark p-2">
                              <h5 className="fs-3 text-wrap run">{runner1}</h5>
                              <p>{bookmakerLiablitiesteam1}</p>
                              
                              {book2?.status === "ACTIVE" ? (
                                <div className="d-flex gap-2">
                                
                                  <div
                                    className="bg-secondary rounded p-2 dnone"
                                    style={{ width: "4rem" }}
                                  ></div>
                                  <div
                                    className="bg-secondary rounded p-2 dnone"
                                    style={{ width: "4rem" }}
                                  ></div>

                                  <div
                                    className="bg-info rounded p-2 text-center fs-5 cursor-pointer"
                                    style={{ width: "4rem" }}
                                    
                                  >
                                    {book2.back_price}
                                  </div>

                                  <div
                                    className="bg-pink1 rounded p-2 text-center fs-5 cursor-pointer"
                                    style={{ width: "4rem"  , backgroundColor:"#E83E8C"}}
                                   
                                  >
                                    {book2.lay_price}
                                  </div>

                                  <div
                                    className="bg-secondary rounded p-2 dnone"
                                    style={{ width: "4rem" }}
                                  ></div>
                                  <div
                                    className="bg-secondary rounded p-2 dnone"
                                    style={{ width: "4rem" }}
                                  ></div>
                                </div>
                              ) : (
                                <div className="bg-info-pink rounded fs-5 d-flex justify-content-center align-items-center media">
                                  {book2?.status}
                                </div>
                              )}
                              
                            </div>

                            <div className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center border-2 bg-dark p-2">
                              <h5 className="fs-3 text-wrap run">{runner2}</h5>

                             <p>{bookmakerLiablitiesteam2}</p>
                              {book1?.status === "ACTIVE" ? (
                                <div className="d-flex gap-2">
                                  
                                  <div
                                    className="bg-secondary rounded p-2 dnone"
                                    style={{ width: "4rem" }}
                                  ></div>
                                  <div
                                    className="bg-secondary rounded p-2 dnone"
                                    style={{ width: "4rem" }}
                                  ></div>

                                  <div
                                    className="bg-info rounded p-2 text-center fs-5 cursor-pointer"
                                   
                                    style={{ width: "4rem" }}
                                  >
                                    {book1.back_price}
                                  </div>

                                  <div
                                    className="bg-pink1 rounded p-2 text-center fs-5 cursor-pointer"
                                    
                                    style={{ width: "4rem" ,  backgroundColor:"#E83E8C"}}
                                  >
                                    {book1.lay_price}
                                  </div>

                                  <div
                                    className="bg-secondary rounded p-2 dnone"
                                    style={{ width: "4rem" }}
                                  ></div>
                                  <div
                                    className="bg-secondary rounded p-2 dnone"
                                    style={{ width: "4rem" }}
                                  ></div>
                                </div>
                              ) : (
                                <div className="bg-info-pink rounded fs-5 d-flex justify-content-center align-items-center media">
                                  {book1?.status}
                                </div>
                              )}

                              
                            </div>
                          </div>
                        )}

                      

                        {/* mini bookmaker data */}
                        {(mini1?.status === "ACTIVE" ||
                          mini2?.status !== "ACTIVE" ||
                          mini1?.status === "SUSPENDED" ||
                          mini2?.status !== "SUSPENDED") && (
                          <>
                            <div className="d-flex align-items-start gap-2 mt-4">
                              <div className="d-flex flex-lg-row flex-column flex-md-row align-items-baseline">
                                <p className="bg-yellow text-black pt-2 pb-2 me-3 px-2 rad bett">
                                  Mini BookMaker
                                </p>
                                {/* <p className="d-flex gap-1 fszz">
                                  <span>
                                    Min:{minMiniBook} <span>|</span>{" "}
                                  </span>{" "}
                                  Max:{maxMiniBook}
                                </p> */}
                              </div>
                               <BetModal betData={betData} />

                              {/* <p
                                className="btn btn-success rounded-pill text-black"
                                style={{ marginTop: "-6px" }}
                              >
                              <i className="bi bi-book"></i>
                              </p> */}

                              {/* Toggle Button - FIXED */}
                              <button
                                className="btn ms-auto me-4 white"
                                onClick={() =>
                                  setIsExpanded1(isExpanded1 === 1 ? 0 : 1)
                                }
                                style={{ fontSize: "1.5rem", lineHeight: 1 }}
                              >
                                {isExpanded1 === 1 ? "−" : "+"}
                              </button>
                            </div>

                            {isExpanded1 === 1 && (
                              <div className="betting-options d-flex flex-column  gap-2">
                                <div className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center border-2 bg-dark p-2">
                                  <h5 className="fs-3 text-wrap run">
                                    {runner1}
                                  </h5>

                                  {mini1?.status === "ACTIVE" ? (
                                    <div className="d-flex gap-2">
                                      
                                      <div
                                        className="bg-secondary rounded p-2 dnone"
                                        style={{ width: "4rem" }}
                                      ></div>
                                      <div
                                        className="bg-secondary rounded p-2 dnone"
                                        style={{ width: "4rem" }}
                                      ></div>

                                      <div
                                        className="bg-info rounded p-2 text-center fs-5 cursor-pointer"
                                        
                                        style={{ width: "4rem" }}
                                      >
                                        {mini1.back_price}
                                      </div>

                                      <div
                                        className="bg-pink1 rounded p-2 text-center fs-5 cursor-pointer"
                                        
                                        style={{ width: "4rem" ,  backgroundColor:"#E83E8C" }}
                                      >
                                        {mini1.lay_price}
                                      </div>

                                      <div
                                        className="bg-secondary rounded p-2 dnone"
                                        style={{ width: "4rem" }}
                                      ></div>
                                      <div
                                        className="bg-secondary rounded p-2 dnone"
                                        style={{ width: "4rem" }}
                                      ></div>
                                    </div>
                                  ) : (
                                    <div className="bg-info-pink rounded fs-5 d-flex justify-content-center align-items-center media">
                                      {mini1?.status}
                                    </div>
                                  )}
                                </div>

                                <div className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center border-2 bg-dark p-2">
                                  <h5 className="fs-3 text-wrap run">
                                    {runner2}
                                  </h5>

                                  {mini2?.status === "ACTIVE" ? (
                                    <div className="d-flex gap-2">
                                      
                                      <div
                                        className="bg-secondary rounded p-2 dnone"
                                        style={{ width: "4rem" }}
                                      ></div>
                                      <div
                                        className="bg-secondary rounded p-2 dnone"
                                        style={{ width: "4rem" }}
                                      ></div>

                                      <div
                                        className="bg-info rounded p-2 text-center fs-5 cursor-pointer"
                                        style={{ width: "4rem" }}
                                       
                                      >
                                        {mini2.back_price}
                                      </div>

                                      <div
                                        className="bg-pink1 rounded p-2 text-center fs-5 cursor-pointer"
                                        style={{ width: "4rem" ,  backgroundColor:"#E83E8C" }}
                                       
                                      >
                                        {mini2.lay_price}
                                      </div>

                                      <div
                                        className="bg-secondary rounded p-2 dnone"
                                        style={{ width: "4rem" }}
                                      ></div>
                                      <div
                                        className="bg-secondary rounded p-2 dnone"
                                        style={{ width: "4rem" }}
                                      ></div>
                                    </div>
                                  ) : (
                                    <div className="bg-info-pink rounded fs-5 d-flex justify-content-center align-items-center media">
                                      {mini2?.status}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </>
                        )}
                       

                        {/* fancy market */}
                        <div className="match-header d-flex flex-column align-items-start gap-2 mt-4 w-100 mb-5">
                          <div className="d-flex align-items-baseline w-100">
                            <p className="bg-yellow text-black pt-3 pb-2 me-5 px-2 rad bett">
                              Fancy Markets
                            </p>

                            <div
                            className="d-flex align-items-end gap-5 ms-0 ms-md-auto me-4 mt-2 mt-md-0 pr-3"
                            style={{ height: "5rem" }}
                          >
                            <p className="text-pink fs-5">No</p>
                            <p className="text-info fs-5">Yes</p>
                          </div>
                          </div>

                          <div className="bg-dark rounded gap-2 d-flex px-3 py-2 d-flex align-items-baseline w-100 pt-2 overflow-auto">
                            <div
                              className={`border border-secondary rounded text-center px-4 py-1 border-warning cursor-pointer bet ${
                                newactive === 0 ? "colr" : ""
                              }`}
                              onClick={() => setNewActive(0)}
                            >
                              ALL
                            </div>
                            <div
                              className={`border border-secondary rounded text-center px-4 py-1 border-warning cursor-pointer bet ${
                                newactive === 1 ? "colr" : ""
                              }`}
                              onClick={() => setNewActive(1)}
                            >
                              SESSION
                            </div>
                            <div
                              className={`border border-secondary rounded text-center px-4 py-1 border-warning cursor-pointer bet text-nowrap ${
                                newactive === 2 ? "colr" : ""
                              }`}
                              onClick={() => setNewActive(2)}
                            >
                              W/P MARKET
                            </div>
                            <div
                              className={`border border-secondary rounded text-center px-4 py-1 border-warning cursor-pointer bet ${
                                newactive === 3 ? "colr" : ""
                              }`}
                              onClick={() => setNewActive(3)}
                            >
                              ODD/EVEN
                            </div>
                            <div
                              className={`border border-secondary rounded text-center px-4 py-1 border-warning cursor-pointer bet ${
                                newactive === 4 ? "colr" : ""
                              }`}
                              onClick={() => setNewActive(4)}
                            >
                              XTRA
                            </div>
                          </div>

                          {/* session */}
                          {Array.isArray(session) &&
                          session.length > 0 &&
                          (newactive === 0 || newactive === 1) ? (
                            <div className="d-flex flex-column align-items-baseline w-100">
                              {/* Add your heading here */}

                              <div className="d-flex  flex-row gappp">
                                <p className="bg-yellow text-black pt-3 pb-3 px-2 rad bett">
                                  Session
                                </p>
                                <button
                                  className="btn ms-auto me-4 white"
                                  onClick={() =>
                                    setIsExpanded3(isExpanded3 === 1 ? 0 : 1)
                                  }
                                  style={{ fontSize: "1.5rem", lineHeight: 1 }}
                                >
                                  {isExpanded3 === 1 ? "−" : "+"}
                                </button>
                              </div>

                              {isExpanded3 === 1 && (
                                <div className="w-100">
                                  {session.map((item, index) => (
                                    <div key={index} className="w-100">
                                      <div className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center border-2 bg-dark p-2 w-100  mb-2">
                                        <h5 className="mb-3 mb-md-0 text-wrap run">
                                          {item?.rate?.fancyName}
                                        </h5>

                                        <div className="d-flex gap-2">
                                          <img
                                            className="small-grid ng-star-inserted mt-4 heig"
                                            src="/assets/images/ladder.svg"
                                            alt="TVKheloyaar360"
                                          />

                                          {item?.status === "ACTIVE" ? (
                                            <>
                                              <div
                                                className="bg-pink1 rounded d-flex flex-column px-3 text-center cursor-pointer"
                                                style={{ width: "70px" ,  backgroundColor:"#E83E8C" }}
                                                
                                              >
                                                <span className="fonts">
                                                  {item?.rate?.rates[0].rate_1}
                                                </span>
                                                <span>
                                                  {item?.rate?.rates[0].value_1}
                                                </span>
                                              </div>

                                              <div
                                                className="bg-info rounded d-flex flex-column px-3 text-center cursor-pointer"
                                                style={{ width: "70px" }}
                                                
                                              >
                                                <span className="fonts">
                                                  {item?.rate?.rates[0]?.rate_2}
                                                </span>
                                                <span>
                                                  {
                                                    item?.rate?.rates[0]
                                                      ?.value_2
                                                  }
                                                </span>
                                              </div>
                                            </>
                                          ) : (
                                            <div className="bg-info-pink rounded p-2 d-flex flex-column px-3 fonts d-flex align-items-center fw-bold">
                                              {item?.status}
                                            </div>
                                          )}
                                        </div>
                                      </div>

                                    
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          ) : (
                            <p className="text-white"></p>
                          )}

                          {/* wpmakrket */}
                          {Array.isArray(wpMarket) &&
                          wpMarket.length > 0 &&
                          (newactive === 0 || newactive === 2) ? (
                            <div className="d-flex flex-column align-items-baseline w-100">
                              {/* Add your heading here */}
                              <div className="d-flex  flex-row gappp">
                                <p className="bg-yellow text-black pt-3 pb-3 px-3 rad bett">
                                  WP Market
                                </p>
                                <button
                                  className="btn ms-auto me-4 white"
                                  onClick={() =>
                                    setIsExpanded4(isExpanded4 === 1 ? 0 : 1)
                                  }
                                  style={{ fontSize: "1.5rem", lineHeight: 1 }}
                                >
                                  {isExpanded4 === 1 ? "−" : "+"}
                                </button>
                              </div>
                              {isExpanded4 === 1 && (
                                <div className="w-100">
                                  {/* Map through wpMarket */}
                                  {wpMarket.map((item, index) => (
                                    <div key={index} className="w-100 mb-2">
                                      <div className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center border-2 bg-dark p-2 w-100 mb-2">
                                        <h5 className="mb-3 mb-md-0 text-wrap run">
                                          {item?.rate?.fancyName}
                                        </h5>

                                        <div className="d-flex gap-2">
                                          <img
                                            className="small-grid ng-star-inserted mt-4 heig"
                                            src="/assets/images/ladder.svg"
                                            alt="TVKheloyaar360"
                                          />

                                          {item?.status === "ACTIVE" ? (
                                            <>
                                              <div
                                                className="bg-pink1 rounded d-flex flex-column px-3 text-center cursor-pointer"
                                                style={{ width: "70px" ,  backgroundColor:"#E83E8C" }}
                                            
                                              >
                                                <span className="fonts">
                                                  {item?.rate?.rates[0].rate_1}
                                                </span>
                                                <span>
                                                  {item?.rate?.rates[0].value_1}
                                                </span>
                                              </div>

                                              <div
                                                className="bg-info rounded d-flex flex-column px-3 text-center cursor-pointer"
                                                style={{ width: "70px" }}
                                              
                                              >
                                                <span className="fonts">
                                                  {item?.rate?.rates[0]?.rate_2}
                                                </span>
                                                <span>
                                                  {
                                                    item?.rate?.rates[0]
                                                      ?.value_2
                                                  }
                                                </span>
                                              </div>
                                            </>
                                          ) : (
                                            <div className="bg-info-pink rounded p-2 d-flex flex-column px-3 fonts d-flex align-items-center fw-bold">
                                              {item?.status}
                                            </div>
                                          )}
                                        </div>
                                      </div>

                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          ) : (
                            <p className="text-white"></p>
                          )}

                          {/* odd even */}
                          {Array.isArray(oddEven) &&
                          oddEven.length > 0 &&
                          (newactive === 0 || newactive === 3) ? (
                            <div className="d-flex flex-column align-items-baseline w-100 mt-0">
                              {/* Add your heading here */}
                              <div className="d-flex  flex-row gappp">
                                <p className="bg-yellow text-black pt-3 pb-3 px-3 rad bett">
                                  ODD/EVEN
                                </p>
                                <button
                                  className="btn ms-auto me-4 white"
                                  onClick={() =>
                                    setIsExpanded6(isExpanded6 === 1 ? 0 : 1)
                                  }
                                  style={{ fontSize: "1.5rem", lineHeight: 1 }}
                                >
                                  {isExpanded6 === 1 ? "−" : "+"}
                                </button>
                              </div>
                              {isExpanded6 === 1 && (
                                <div className="w-100">
                                  {/* Map through wpMarket */}
                                  {oddEven.map((item, index) => (
                                    <div key={index} className="w-100">
                                      <div className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center border-2 bg-dark p-2 w-100 mb-2">
                                        <h5 className="mb-3 mb-md-0 text-wrap run">
                                          {item?.rate?.fancyName}
                                        </h5>

                                        <div className="d-flex gap-2">
                                          <img
                                            className="small-grid ng-star-inserted mt-4 heig"
                                            src="/assets/images/ladder.svg"
                                            alt="TVKheloyaar360"
                                          />

                                          {item?.status === "ACTIVE" ? (
                                            <>
                                              <div
                                                className="bg-pink1 rounded d-flex flex-column px-3 text-center cursor-pointer"
                                                style={{ width: "70px" ,  backgroundColor:"#E83E8C" }}
                                                
                                              >
                                                <span className="fonts">
                                                  {item?.rate?.rates[0].rate_1}
                                                </span>
                                                <span>
                                                  {item?.rate?.rates[0].value_1}
                                                </span>
                                              </div>

                                              <div
                                                className="bg-info rounded d-flex flex-column px-3 text-center cursor-pointer"
                                                style={{ width: "70px" }}
                                               
                                              >
                                                <span className="fonts">
                                                  {item?.rate?.rates[0]?.rate_2}
                                                </span>
                                                <span>
                                                  {
                                                    item?.rate?.rates[0]
                                                      ?.value_2
                                                  }
                                                </span>
                                              </div>
                                            </>
                                          ) : (
                                            <div className="bg-info-pink rounded p-2 d-flex flex-column px-3 fonts d-flex align-items-center fw-bold">
                                              {item?.status}
                                            </div>
                                          )}
                                        </div>
                                      </div>

                                 
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          ) : (
                            <p className="text-white"></p>
                          )}

                          {/* xtra */}
                          {Array.isArray(fancy) &&
                          fancy.length > 0 &&
                          (newactive === 0 || newactive === 4) ? (
                            <div className="d-flex flex-column align-items-baseline w-100">
                              {/* Add your heading here */}
                              <div className="d-flex  flex-row gappp">
                                <p className="bg-yellow text-black pt-3 pb-3 px-3 rad bett">
                                  XTRA
                                </p>
                                <button
                                  className="btn ms-auto me-4 white"
                                  onClick={() =>
                                    setIsExpanded5(isExpanded5 === 1 ? 0 : 1)
                                  }
                                  style={{ fontSize: "1.5rem", lineHeight: 1 }}
                                >
                                  {isExpanded5 === 1 ? "−" : "+"}
                                </button>
                              </div>

                              {isExpanded5 === 1 && (
                                <div className="w-100">
                                  {/* Map through wpMarket */}
                                  {fancy.map((item, index) => (
                                    <div key={index} className="w-100">
                                      <div className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center border-2 bg-dark p-2 w-100 mb-2">
                                        <h5 className="mb-3 mb-md-0 text-wrap run">
                                          {item?.rate?.fancyName}
                                        </h5>

                                        <div className="d-flex gap-2">
                                          <img
                                            className="small-grid ng-star-inserted mt-4 heig"
                                            src="/assets/images/ladder.svg"
                                            alt="TVKheloyaar360"
                                          />

                                          {item?.status === "ACTIVE" ? (
                                            <>
                                              <div
                                                className="bg-pink1 rounded d-flex flex-column px-3 text-center cursor-pointer"
                                                style={{ width: "70px" ,  backgroundColor:"#E83E8C" }}
                                               
                                              >
                                                <span className="fonts">
                                                  {item?.rate?.rates[0].rate_1}
                                                </span>
                                                <span>
                                                  {item?.rate?.rates[0].value_1}
                                                </span>
                                              </div>

                                              <div
                                                className="bg-info rounded d-flex flex-column px-3 text-center cursor-pointer"
                                                style={{ width: "70px" }}
                                                
                                              >
                                                <span className="fonts">
                                                  {item?.rate?.rates[0]?.rate_2}
                                                </span>
                                                <span>
                                                  {
                                                    item?.rate?.rates[0]
                                                      ?.value_2
                                                  }
                                                </span>
                                              </div>
                                            </>
                                          ) : (
                                            <div className="bg-info-pink rounded p-2 d-flex flex-column px-3 fonts d-flex align-items-center fw-bold">
                                              {item?.status}
                                            </div>
                                          )}
                                        </div>
                                      </div>

                                   
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          ) : (
                            <p className="text-white"></p>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="bets-container d-flex flex-column betTv  gap-2    ">
                      <div className="d-none d-lg-block position-relative pl-1 ">
                        {" "}
                        {/* Added position relative */}
                        <div
                          className=" p-2 cursor-pointer d-flex justify-content-between"
                          style={{ background: "#212121" }}
                          onClick={() => setPlay(!play)}
                        >
                          <div>
                            <span>
                              {" "}
                              <i
                                className="bi bi-broadcast fs-16"
                                style={{ color: "#DC3545" }}
                              ></i>
                            </span>
                            <span> Watch Live Match</span>
                          </div>
                          <div>
                            <button className="live-stream-button ng-star-inserted">
                              {" "}
                              Watch Live{" "}
                            </button>
                          </div>
                        </div>
                        {play && (
                          <iframe
                            title="Live TV"
                            className="border w-100 h-75"
                            src={`https://5por-tt1.top/directstreaming.php?chid=${channel}`}
                            allowFullScreen
                            referrerPolicy="strict-origin-when-cross-origin"
                            sandbox="allow-same-origin allow-scripts"
                          ></iframe>
                        )}
                      </div>

                      <div
                        className="rounded-4 mt-3 mt-lg-0 ms-0 ms-lg-1 mb-4  h-100"
                        style={{
                          maxHeight: "100vh",
                          height: `${betData.length * 6}vh`,
                        }}
                      >
                        <div
                          className="m-0 rounded-top-3 p-2 bett"
                          style={{
                            background:
                              "linear-gradient(to right, #f2d71a, #ecb024)",
                            color: "#000",
                          }}
                        >
                          My Bets
                        </div>

                        <table
                          className=" border  w-100"
                          style={{ borderCollapse: "collapse" }}
                        >
                          <thead>
                            <div
                              style={{
                                color: "white",
                                fontFamily: "sans-serif",
                              }}
                              className="pl-1"
                            >
                              Unmatched bets
                            </div>
                            <tr>
                              <th>Runner Name</th>
                              <th>ODDS</th>
                              <th>Bet Amount</th>
                              <th>P/L</th>
                            </tr>
                          </thead>

                          <tbody>
                            {unmatch?.length > 0 ? (
                              unmatch?.map((bet, index) => (
                                <tr key={index}>
                                  <td>
                                    {bet.runnerName}&nbsp;({bet.type})
                                  </td>
                                  <td>{bet.betprice}</td>
                                  <td>{bet.betAmount}</td>
                                  <td>{bet.profit}</td>
                                </tr>
                              ))
                            ) : (
                              <tr></tr>
                            )}
                          </tbody>
                        </table>
                        <table
                          className="table border  w-100"
                          style={{ borderCollapse: "collapse" }}
                        >
                          <thead>
                            <div
                              style={{
                                color: "white",
                                fontFamily: "sans-serif",
                              }}
                              className="pl-1"
                            >
                              Matched bets
                            </div>
                            <tr>
                              <th>Phone</th>

                              <th className="headerColor">Runner Name</th>
                              <th>ODDS</th>
                              <th>Bet Amount</th>
                              <th>P/L</th>
                            </tr>
                          </thead>

                          <tbody>
                            {/* Sports Bets */}
                            {betData?.length > 0 ? (
                              <>
                                <tr>
                                  <th
                                    colSpan={4}
                                    style={{
                                      background: "#000",
                                      color: "#fff",
                                    }}
                                  >
                                    Sports Bets
                                  </th>
                                </tr>
                                {betData.map((bet, index) => (
                                  <tr key={`sports-${index}`}>
                                    <td>
                                      {bet.phone}
                                    </td>
                                    <td>
                                      {bet.runnerName} ({bet.type})
                                    </td>
                                    <td>{bet.betprice}</td>
                                    <td>{bet.betAmount}</td>
                                    <td>{bet.profit}</td>
                                  </tr>
                                ))}
                              </>
                            ) : (
                              <tr>
                                <td
                                  colSpan={4}
                                  style={{ color: "gray", textAlign: "center" }}
                                >
                                  No sports bet data
                                </td>
                              </tr>
                            )}

                            {/* Fancy Bets */}
                            {fancyBetData?.length > 0 ? (
                              <>
                                <tr>
                                  <th
                                    colSpan={4}
                                    style={{
                                      background: "#000",
                                      color: "#fff",
                                    }}
                                  >
                                    Fancy Bets
                                  </th>
                                </tr>
                                {fancyBetData.map((bet, index) => (
                                  <tr key={`fancy-${index}`}>
                                    <td>
                                      {bet.phone}
                                    </td>
                                    <td>
                                      {bet.runnerName} ({bet.type})
                                    </td>
                                    <td>{bet.rate}</td>
                                    <td>{bet.betAmount}</td>
                                    <td>{bet.profit}</td>
                                  </tr>
                                ))}
                              </>
                            ) : (
                              <tr>
                                <td
                                  colSpan={4}
                                  style={{ color: "gray", textAlign: "center" }}
                                >
                                  No fancy bet data
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>

                  </div>
                </div>
              
            </div>
</div>

    </div>

    </>
  );
};

export default MarketAnalysisBets;
